import store from "@/lobby_common/store/index";
import { eventPost } from "./eventFunction";
import { getAnyZone } from "./utils";
// 凌晨上报一次登陆事件
let zeroTimer = null;
let server_time = 0;
export function repairLoginEvent(timestamp = 0) {
  try {
    if (!timestamp) return;
    let hoursNum = 0 // 时
    let minutesNum = 0 // 分
    let secondsNum = 10 // 秒
    // debug
    // let debugLoginEventTime = localStorage.getItem('debugLoginEventTime')
    // if (debugLoginEventTime) {
    //   let arr = debugLoginEventTime.split(':')
    //   hoursNum = Number(arr[0])
    //   minutesNum = Number(arr[1])
    //   secondsNum = Number(arr[2])
    // }
    server_time = timestamp * 1000;
    server_time = getAnyZone(server_time).getTime();
    // server_time = 1691683190000;
    clearInterval(zeroTimer);
    zeroTimer = setInterval(() => {
      server_time += 1000;
      const date = new Date(server_time);
      // 获取小时、分钟和秒
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      if (store.getters.login && hours === hoursNum && minutes === minutesNum && seconds <= secondsNum) {
        clearInterval(zeroTimer);
        // console.log("凌晨----上报登陆事件");
        eventPost('login_click_success')
      }
      // console.log("zeroTimer", server_time, `${hours}:${minutes}:${seconds}`);
    }, 1000);
  } catch (error) {
    console.log(error)
  }
}
